import type { ReactNode } from "react";
import { ArrowLeft } from "lucide-react";

export function BackHeader({ title, onBack }: { title: string; onBack: () => void }) {
  return (
    <div style={{ padding: "16px 16px 4px", display: "flex", alignItems: "center", gap: 8 }}>
      <button
        type="button"
        onClick={onBack}
        aria-label="Назад"
        style={{
          background: "transparent",
          border: 0,
          color: "var(--fg2)",
          cursor: "pointer",
          padding: 4,
          display: "inline-flex",
        }}
      >
        <ArrowLeft size={22} />
      </button>
      <h1 className="h2" style={{ margin: 0, fontSize: 22 }}>{title}</h1>
    </div>
  );
}

export function Card({ children, accent = false }: { children: ReactNode; accent?: boolean }) {
  return (
    <div
      style={{
        background: accent ? "var(--brand-orange-ghost)" : "var(--bg-section)",
        border: accent ? "1px solid var(--brand-orange)" : "1px solid transparent",
        borderRadius: "var(--r-lg)",
        margin: "12px 16px",
        padding: 16,
      }}
    >
      {children}
    </div>
  );
}

/**
 * Plain <div> wrapper (not <label>) — composite pickers inside a <label>
 * swallow clicks in some Chromium builds (see CreateChallengeDialog).
 */
export function Field({ label, hint, children }: { label: string; hint?: ReactNode; children: ReactNode }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6, padding: "10px 16px" }}>
      <span className="label" style={{ color: "var(--fg2)" }}>{label}</span>
      {children}
      {hint && <span className="caption" style={{ color: "var(--fg3)" }}>{hint}</span>}
    </div>
  );
}

export function Muted({ children }: { children: ReactNode }) {
  return <div className="caption" style={{ color: "var(--fg3)", marginTop: 4 }}>{children}</div>;
}

export function ErrorBox({ error }: { error: unknown }) {
  if (!error) return null;
  return (
    <div
      style={{
        background: "rgba(223,63,64,0.1)",
        color: "var(--fg-danger)",
        padding: "8px 12px",
        borderRadius: "var(--r-md)",
        fontSize: 13,
        margin: "8px 16px",
      }}
    >
      {(error as Error).message}
    </div>
  );
}
